module.exports = __webpack_public_path__ + "static/img/27.c0fa982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/27.jpg
// module id = OFG5
// module chunks = 0